import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  public isView = signal<boolean>(false);

  private callCount = 0; // Contador para balancear show/hide

  public hide() {
    this.callCount--;

    if (this.callCount <= 0) {
      this.callCount = 0;
      this.isView.set(false);
    }
  }

  public show() {
    this.callCount++;
    this.isView.set(true);
  }

  public reset() {
    this.callCount = 0;
    this.isView.set(false);
  }

  public getCallCount() {
    return this.callCount;
  }
}
